__turbopack_context__.v({
  "fade-in": "AnimatedIconFarmers-module-scss-module__98VBZW__fade-in",
  "root": "AnimatedIconFarmers-module-scss-module__98VBZW__root",
});
